<template>
  <div style="background-color: #161922;min-height: 100vh;overflow-y: scroll;">
      <nav-bar class="title_top" :icon="'img/backw.png'" :textColor="'#fff'" :backColor="'#161922'" />
   <div class="index_rule" style="background-image: url('img/index_bg.png');">

   </div>

  </div>
</template>

<script>
import "@/assets/css/base.css"
import "@/assets/css/index.css"
import NavBar from '@/components/navBar.vue';
export default {
  name: 'rule',
  components: {
    NavBar
  },
  data() {
    return {
        
    };
  },
  created() {
  },
  methods: {

  },
};
</script>